import { container, grid, pageMargin } from "../layout";
import { space } from "./spacing";

/**
 * Semantic layout roles — app shell and content constraints over primitive layout tokens.
 * Sidebar/drawer/form values align with Sidebar/styles and FormSection defaults.
 */
export const layout = {
  pageMargin,
  container,
  grid,
  sidebar: {
    expanded: 240,
    collapsed: 60,
    iconColumn: 45,
  },
  drawer: {
    default: 500,
    min: 50,
  },
  dialog: {
    /** Matches MUI `maxWidth="sm"` / `container.sm` — default AppDialog floor */
    minWidth: container.sm,
    minHeight: 220,
    paddingX: space.inset.lg,
    titlePaddingY: space.inset.xs,
    bodyPaddingY: space.inset.sm,
    actionsPaddingY: space.inset.sm,
  },
  form: {
    maxWidth: 1100,
  },
} as const;

export type TLayoutSemantic = typeof layout;
